<div id="itinerary" [class.itinerary-synthetic]="isSynthetic">
  <ng-container *ngIf="isSynthetic; else detailedItinerary">
    <ng-template #serviceRows let-day>
      <ng-container *ngFor="let row of day.rows">
        <div class="svc">
          <span class="svc-title">
            <span class="svc-time" *ngIf="row.time">{{ row.time }}</span>{{ row.name }}
            <button type="button" class="svc-link" (click)="goToServiceTab(row.type, row.code)" [attr.aria-label]="row.name">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M14 3h7v7h-2V6.4l-8.3 8.3-1.4-1.4L17.6 5H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" />
              </svg>
            </button>
          </span>
          <p class="svc-desc" *ngIf="row.description">{{ row.description }}</p>
          <div class="svc-step" *ngFor="let step of row.steps">
            <span class="svc-step-city">{{ step.cityName }}</span>
            <span class="svc-step-date" *ngIf="step.dateFrom">{{ step.dateFrom | localizedDate: "dd.MM"
              }}<ng-container *ngIf="step.dateTo"> – {{ step.dateTo | localizedDate: "dd.MM" }}</ng-container></span>
            <p class="svc-desc" *ngFor="let text of step.descriptions" [innerHTML]="text | safeHtml"></p>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ngFor="let block of blocks; let blockIndex = index">
      <div class="itinerary-block container" [class.itinerary-tour]="block.type === 'tour'">
        <ng-container *ngIf="block.type === 'tour'; else cityBlock">
          <div class="hero tour">
            <img class="hero-img" [src]="block.tour?.image" [alt]="block.tour?.name"
              [fallbackSrc]="defaultImages?.escorted || noImageUrl"
              [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'" />
            <div class="hero-overlay"></div>
            <div class="hero-title">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M12 2C8.1 2 5 5.1 5 9c0 5.3 7 13 7 13s7-7.7 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
              </svg>
              {{ block.tour?.name }}
            </div>
            <div class="hero-dates" *ngIf="block.endDate">
              Dal {{ block.startDate | localizedDate: "dd.MM" }} al {{ block.endDate | localizedDate: "dd.MM" }}
            </div>
            <div class="hero-dates" *ngIf="!block.endDate">
              {{ block.startDate | localizedDate: "dd.MM.yyyy" }}
            </div>
          </div>

          <p class="loc-desc" *ngIf="block.tour?.abstract" [innerHTML]="block.tour.abstract | safeHtml"></p>
          <div class="tappa-meta" *ngIf="block.tour?.meta?.length">
            <span *ngFor="let meta of block.tour.meta"><strong>{{ meta.label | translate }}:</strong>
              {{ meta.value }}</span>
          </div>

          <!-- <div class="tappa-rimandi" *ngIf="block.rimandi?.length">
            <button type="button" class="rimando" *ngFor="let rimando of block.rimandi"
              (click)="goToServiceTab(rimando.type, rimando.code)" [attr.aria-label]="rimando.label | translate"
              [attr.title]="rimando.label | translate">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M14 3h7v7h-2V6.4l-8.3 8.3-1.4-1.4L17.6 5H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" />
              </svg>
            </button>
          </div> -->

          <div class="day-card" *ngFor="let tourDay of block.days; let dayIndex = index">
            <div class="day-head">
              <div class="h-left">
                <span class="day-when">{{ tourDay.date | localizedDate: "dd.MM" }} · {{ "ITINERARY.DAY" | translate |
                  titlecase }} {{ tourDay.number }}</span>
                <span class="day-city" *ngIf="tourDay.city_name">{{ tourDay.city_name }}</span>
              </div>
              <button type="button" class="day-toggle" (click)="toggleDay(blockIndex, dayIndex)">
                {{ (isDayCollapsed(blockIndex, dayIndex) ? "ITINERARY.EXPAND" : "ITINERARY.CLOSE") | translate }}
              </button>
            </div>
            <div class="day-body" *ngIf="!isDayCollapsed(blockIndex, dayIndex)">
              <p class="day-text" *ngFor="let text of tourDay.texts" [innerHTML]="text | safeHtml"></p>
              <ng-container *ngTemplateOutlet="serviceRows; context: { $implicit: tourDay }"></ng-container>
            </div>
          </div>
        </ng-container>

        <ng-template #cityBlock>
        <div class="hero">
          <img class="hero-img" [src]="urlCitiesImages + (block.day?.city_photo || '')" [alt]="block.city_name"
            [fallbackSrc]="defaultImages?.city || noImageUrl"
            [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'" />
          <div class="hero-overlay"></div>
          <div class="hero-title">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 2C8.1 2 5 5.1 5 9c0 5.3 7 13 7 13s7-7.7 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
            </svg>
            {{ block.day?.city_title?.trim() || block.city_name }}
          </div>
          <div class="hero-dates" *ngIf="block.endDate">
            Dal {{ block.day.date | localizedDate: "dd.MM" }} al {{ block.endDate | localizedDate: "dd.MM" }}
          </div>
          <div class="hero-dates" *ngIf="!block.endDate">
            {{ block.day.date | localizedDate: "dd.MM.yyyy" }}
          </div>
        </div>

        <div class="day-card" *ngFor="let day of block.days; let dayIndex = index">
          <div class="day-head">
            <div class="h-left">
              <span class="day-when">{{ day.date | localizedDate: "dd.MM" }} · {{ "ITINERARY.DAY" | translate |
                titlecase }} {{ day.number }}</span>
              <span class="day-city">{{ day.city_name || block.city_name }}</span>
            </div>
            <button type="button" class="day-toggle" (click)="toggleDay(blockIndex, dayIndex)">
              {{ (isDayCollapsed(blockIndex, dayIndex) ? "ITINERARY.EXPAND" : "ITINERARY.CLOSE") | translate }}
            </button>
          </div>
          <div class="day-body" *ngIf="!isDayCollapsed(blockIndex, dayIndex)">
            <ng-container *ngTemplateOutlet="serviceRows; context: { $implicit: day }"></ng-container>
          </div>
        </div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #detailedItinerary>
  <ng-container *ngFor="let day of days; let index = index">
    <ng-container *ngIf="enableItineraryViewServices; else notEnabled">
      <div class="container-fluid card card-body sticky-top day-header">
        <div class="row">
          <div class="col-12 text-secondary text-uppercase">
            <span class="text-08em">{{day.date | localizedDate : "MMM dd, yyyy"}}</span>
          </div>
          <div class="col-12 text-capitalize">
            <span class="text-13em">{{ day.date | localizedDate: "EEEE"}}</span>
          </div>
        </div>
      </div>

      <div *ngIf="!hideCity">
        <app-city z-index="10" [urlCitiesImages]="urlCitiesImages" [day]="processedDays[index]" [version]="version"
          [noImageUrl]="noImageUrl" [enableTravelStepsTab]="enableTravelStepsTab">
        </app-city>
      </div>

      <ng-container *ngFor="let serviceType of processedDays[index].serviceOrder">
        <ng-container [ngSwitch]="serviceType.type">
          <app-flights *ngSwitchCase="'flight'" z-index="10" [day]="getSingleServiceDay(processedDays[index], serviceType.type, serviceType.index)" [enableFlightPassengers]="enableFlightPassengers"></app-flights>
          <app-vehicles *ngSwitchCase="'vehicle'" z-index="10" [day]="getSingleServiceDay(processedDays[index], serviceType.type, serviceType.index)" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.auto" [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-vehicles>
          <app-transfers *ngSwitchCase="'transfer'" z-index="10" [day]="getSingleServiceDay(processedDays[index], serviceType.type, serviceType.index)" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.transfer" [showOptionlServices]="showOptionlServices" [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-transfers>
          <app-hotels *ngSwitchCase="'hotel'" z-index="10" [day]="getSingleServiceDay(processedDays[index], serviceType.type, serviceType.index)" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.hotel" [showOptionlServices]="showOptionlServices" [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-hotels>
          <app-optionals *ngSwitchCase="'optional'" z-index="10" [day]="getSingleServiceDay(processedDays[index], serviceType.type, serviceType.index)" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.activity" [showOptionlServices]="showOptionlServices" [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-optionals>
        </ng-container>
      </ng-container>

      <app-escorted z-index="10" [day]="processedDays[index]" [version]="version"
        [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.escorted" [totalPax]="totalPax" [serviceIcons]="serviceIcons"
        [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"></app-escorted>
    </ng-container>
    <ng-template #notEnabled>
      <div class="container-fluid card card-body sticky-top day-header"
        *ngIf="!!day.city_name && day.showDetailsOnItinerary && !day.isLastDay;">
        <div class="row">
          <div class="col-12 text-secondary text-uppercase">
            <span class="text-08em">{{day.date | localizedDate : "MMM dd, yyyy"}}</span>
          </div>
          <div class="col-12 text-capitalize">
            <span class="text-13em">{{ day.date | localizedDate: "EEEE"}}</span>
          </div>
        </div>
      </div>

      <div *ngIf="!hideCity">
        <app-city z-index="10" [urlCitiesImages]="urlCitiesImages" [day]="day" [version]="version"
          [noImageUrl]="noImageUrl" [endDate]="cityEndDates.get(day.city_name)"
          [enableTravelStepsTab]="enableTravelStepsTab">
        </app-city>
      </div>
    </ng-template>
  </ng-container>
  </ng-template>
</div>


<div class="program-block" *ngIf="!enableItineraryViewServices">
  <div class="block">
    <h2>Programma</h2>
    <ng-container *ngFor="let day of days; let index = index">
      <ng-container *ngIf="!!day.city_name && day.showDetailsOnItinerary && !day.isLastDay;">
        <a [href]="getAnchorUrl(day.city_name)" class="text-capitalize" [class.active]="isActiveLink(day.city_name)"
          (click)="setActiveLink(day.city_name)">
          {{ day.city_name?.toLowerCase() }}
        </a>
      </ng-container>
    </ng-container>
  </div>
</div>